import { render, staticRenderFns } from "./HbyPrizeTable.vue?vue&type=template&id=4701fb85&scoped=true&"
import script from "./HbyPrizeTable.vue?vue&type=script&lang=js&"
export * from "./HbyPrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./HbyPrizeTable.vue?vue&type=style&index=0&id=4701fb85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701fb85",
  null
  
)

export default component.exports